import React from 'react'
import { useSelector } from 'react-redux'
import {
  getIsLoaded,
  getPage,
  getPageCount,
  getSortedSEOPages,
  getSearchString,
  getFilters,
  getSorter,
  getIsDataFilteredOrSorted,
} from 'domains/SEOPages/selectors'
import {
  fetchSEOPages,
  changeSEOPagePublishState,
} from 'actions/views/productFamilies'
import useAction from 'utils/useAction'
import { Buttons, StyledTable, Wrapper } from './SEOPages.styles'
import getColumns from './columns'
import { getRowClassByTagID, getRowKey } from 'helpers/tables'
import { openConfirmModal, openSEOPageModal } from 'reducers/modals/actions'
import { HEADER_OFFSET, PAGE_SIZE, SCROLL } from 'const/tables'
import { Button } from 'antd'
import SearchInTableBar from 'components/SearchInTableBar'
import { FIELD_NAMES } from 'const/forms'
import { isEqual } from 'lodash'

const SEOPages = () => {
  const isLoaded = useSelector(getIsLoaded)
  const page = useSelector(getPage)
  const search = useSelector(getSearchString)
  const pageCount = useSelector(getPageCount)
  const filters = useSelector(getFilters)
  const sorter = useSelector(getSorter)
  const dataSource = useSelector(getSortedSEOPages)
  const isDataFilteredOrSorted = useSelector(getIsDataFilteredOrSorted)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openSEOPageModalFunc = useAction(openSEOPageModal)

  const fetchSEOPagesFunc = useAction(fetchSEOPages)
  const changeSEOPagePublishStateFunc = useAction(changeSEOPagePublishState)

  const handleEditProduct = (id) => openSEOPageModalFunc({ id })

  const handleChangeSEOPagePublishState = (product) => {
    const callback = () => changeSEOPagePublishStateFunc(product)
    const text = `Are you sure you want to ${
      product[FIELD_NAMES.isPublished] ? 'unpublish' : 'publish'
    } SEO page ${product[FIELD_NAMES.name]} (ID: ${
      product[FIELD_NAMES.id]
    })? This action can't be revoked.`
    openConfirmModalFunc({ callback, text })
  }

  const onSearchStringChange = (search) =>
    fetchSEOPagesFunc({
      page: 1,
      search,
      filters,
      sorter,
    })

  const onTableChange = (pagination, newFilters, newSorter) => {
    const pageChanged = page !== pagination.current
    const newFiltersOrSorter =
      !pageChanged &&
      (!isEqual(newFilters, filters) || !isEqual(newSorter, sorter))
    fetchSEOPagesFunc({
      page: newFiltersOrSorter ? 1 : pagination.current,
      search,
      filters: newFilters,
      sorter: newSorter,
    })
  }

  const handleResetFilters = () =>
    fetchSEOPagesFunc({
      search,
      page: 1,
      filters: {},
      sorter: {},
    })

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: pageCount * PAGE_SIZE,
    pageSize: PAGE_SIZE,
    current: page,
    showSizeChanger: false,
  }

  return (
    <Wrapper>
      <SearchInTableBar
        placeholder="Search SEO page"
        onSubmit={onSearchStringChange}
        value={search}
      >
        <Buttons>
          <Button
            onClick={handleResetFilters}
            disabled={!isLoaded || !isDataFilteredOrSorted}
          >
            Reset filters
          </Button>
        </Buttons>
      </SearchInTableBar>
      <StyledTable
        onChange={onTableChange}
        showSorterTooltip={false}
        columns={getColumns(
          filters,
          sorter,
          handleEditProduct,
          handleChangeSEOPagePublishState
        )}
        dataSource={dataSource}
        expandable={false}
        pagination={paginationConfig}
        sticky={isLoaded && HEADER_OFFSET}
        scroll={SCROLL}
        bordered
        loading={false}
        rowKey={getRowKey}
        rowClassName={getRowClassByTagID}
      />
    </Wrapper>
  )
}

export default SEOPages
